import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const CustomProductionFormStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "custom_production_form",
})`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-inline-end: 48px;
`;
